import { render } from "./CIS-Resource-Podcast.vue?vue&type=template&id=5285ecda&scoped=true"
import script from "./CIS-Resource-Podcast.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Podcast.vue?vue&type=script&lang=js"

import "./CIS-Resource-Podcast.vue?vue&type=style&index=0&id=5285ecda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5285ecda"]])

export default __exports__